import styled from "styled-components";

import RichText from "../rich-text";

const Blockquote = styled.blockquote`
  font-size: 1.25em;
  line-height: 1.75em;
  margin: 0 0 1rem 0;
  padding: 1.5rem 0 0 1rem;
  border-left: 0.15em solid blue;
  font-weight: bold;
  position: relative;

  &::before {
    content: "“";
    position: absolute;
    font-size: 2.5em;
    left: 1rem;
    top: 0.5rem;
  }

  &::after {
    content: "”";
    display: inline;
  }

  p {
    display: inline;
  }
`;

const Quote = ({ content }) => {
  return (
    <Blockquote>
      <RichText content={content} />
    </Blockquote>
  );
};

export default Quote;
